<template>
  <v-select
    v-model="selectedValues"
    multiple
    chips
    hide-details
    clearable
    :items="items"
    :item-text="itemText"
    :item-value="itemValue"
    :label="label"
    @input="emitChange"
  >
    <template v-slot:prepend-item>
      <v-list-item ripple @click="toggle">
        <v-list-item-action>
          <v-icon :color="selectedValues.length > 0 ? 'indigo darken-4' : ''">
            {{ selectIcon }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            全選
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
  </v-select>
</template>

<script>
export default {
  name: 'SelectWithSelectAll',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: ''
    },
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    }
  },
  data () {
    return {
      selectedValues: this.value
    }
  },
  computed: {
    selectIcon () {
      if (this.selectedValues.length === this.items.length) return 'mdi-close-box'
      return 'mdi-checkbox-blank-outline'
    }
  },
  watch: {
    value (newVal) {
      this.selectedValues = newVal
    }
  },
  methods: {
    toggle () {
      const allSelected = this.selectedValues.length === this.items.length
      if (allSelected) {
        this.selectedValues = []
      } else {
        this.selectedValues = this.items.map(e => e[this.itemValue])
      }
      this.emitChange()
    },
    emitChange () {
      this.$emit('input', this.selectedValues)
    }
  }
}
</script>